import React from "react"
import { Formik, Form, Field, FormikHelpers, useFormik } from "formik"
import * as Yup from "yup"
import { Input, InputWrapper } from "../composites"
import { Grid } from "@chakra-ui/layout"
import { Select } from "@chakra-ui/select"
import _ from "lodash"
import { Button } from "@chakra-ui/button"
import { createTransaction } from "../../services/crm.service"
import { useShowToastHook } from "../../hooks/show-toast-hook"

const TYPE = {
  DEPOSIT: "Deposit",
  WITHDRAW: "Withdraw",
  CREDIT_IN: "Credit In",
  CREDIT_OUT: "Credit Out",
}

const transactionSchema = Yup.object().shape({
  login: Yup.number().required("Login is required!"),
  amount: Yup.number().min(1).required("Login is required!"),
})

const CreateTransactionsForm = () => {
  const { showError, showSuccess } = useShowToastHook()

  const formik = useFormik({
    initialValues: {
      login: undefined,
      type: TYPE.DEPOSIT,
      amount: 0,
      comment: "",
    },
    validationSchema: transactionSchema,
    onSubmit: async (values, actions) => {
      let amt = values?.amount

      if (values?.type === "WITHDRAW" || values?.type === "CREDIT_OUT") {
        amt = -amt
      }

      let type = 2

      if (values?.type === "CREDIT_IN" || values?.type === "CREDIT_OUT") {
        type = 3
      }

      if (!values?.login) return

      actions.setSubmitting(true)

      try {
        const result = await createTransaction(
          values?.login,
          amt,
          type,
          "Manager API " + values?.comment
        )

        if (result?.data?.status) {
          showSuccess("Transaction Successfull")
        } else {
          showError(
            result?.data?.message ??
              "Something went wrong, please try again later."
          )
        }
      } catch (error) {
        showError("Something went wrong, please try again later.")
      }

      actions.setSubmitting(false)
    },
  })

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid
          my={6}
          gap={6}
          width="100%"
          maxWidth={["100%", "100%", "400px", "400px"]}
        >
          <Input
            title="Login"
            type="number"
            name="login"
            value={formik?.values?.login}
            onChange={formik?.handleChange}
            onBlur={formik?.handleBlur}
            errorMessage={
              formik?.touched?.login && formik?.errors?.login
                ? formik?.errors?.login
                : ""
            }
          />

          <InputWrapper
            title="Type"
            errorMessage={
              formik?.touched?.type && formik?.errors?.type
                ? formik?.errors?.type
                : ""
            }
          >
            <Select
              name="type"
              value={formik?.values?.type}
              onChange={formik?.handleChange}
              onBlur={formik?.handleBlur}
            >
              {_.map(Object.keys(TYPE), (_t: any) => (
                <option value={_t}>
                  {/* @ts-ignore */}
                  {TYPE[_t]}
                </option>
              ))}
            </Select>
          </InputWrapper>

          <Input
            title="Amount"
            type="number"
            name="amount"
            value={formik?.values?.amount}
            onChange={formik?.handleChange}
            onBlur={formik?.handleBlur}
            errorMessage={
              formik?.touched?.amount && formik?.errors?.amount
                ? formik?.errors?.amount
                : ""
            }
          />

          <Input
            title="Comment"
            type="test"
            name="comment"
            value={formik?.values?.comment}
            onChange={formik?.handleChange}
            onBlur={formik?.handleBlur}
            errorMessage={
              formik?.touched?.comment && formik?.errors?.comment
                ? formik?.errors?.comment
                : ""
            }
          />

          <Button
            colorScheme="blue"
            type="submit"
            isLoading={formik?.isSubmitting}
          >
            Create
          </Button>
        </Grid>
      </form>
    </>
  )
}

export default CreateTransactionsForm
